// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1TDrF","infoBtn":"quickbooks_infoBtn__1jIBg","formBox":"quickbooks_formBox__W5iFa","formFooter":"quickbooks_formFooter__2Xhz4"};